import React from "react";

import styles from "./SubtractInputField.module.css"
import {CustomSmallInputField} from "../customSmallInputField/CustomSmallInputField";
import {SubtractSwitcher} from "../subtractSwitcher/SubtractSwitcher";
import {SubtractionType} from "../../../api/generated";

interface FieldProps {
    type?: string
    disabled?: boolean
    value?: any
    setValue: (value: any) => void
    subtractionType: SubtractionType
    onSubtractionChange: (value: SubtractionType) => void
    placeholder?: string
    errorMessage?: string
    title?: string
}


export const SubtractInputField: React.FC<FieldProps> = ({
                                                             type,
                                                             disabled,
                                                             value,
                                                             setValue,
                                                             placeholder,
                                                             errorMessage,
                                                             subtractionType,
                                                             onSubtractionChange,
                                                             title = "subtract"
                                                         }) => {

    return <div className={styles.wrapper}>
        <span className={styles.subtract}>{title}</span>
        <CustomSmallInputField
            type={type}
            value={value}
            setValue={setValue}
            disabled={disabled}
            placeholder={placeholder}
            errorMessage={errorMessage}
            subtractionType={subtractionType}
        />
        <SubtractSwitcher subtractionType={subtractionType} setSubtractionType={onSubtractionChange}/>
    </div>
}
